import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import BaseMnTree from "@mnjsplatform/components/lib/common/BaseMnTree";
import FileDownloadHandle from "@mnjsplatform/components/lib/common/InputField/FileDownloadHandle";

class Acquaintance_LNA extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem.execute({}, {treeExpanded: false, withParams:false}));
            if(!this.props.dataItem.isError)
                await this.selectTreeRow(0, true);
        } catch (e) {
            console.error(e);
        }
    }

    selectTreeRow = async (rowIndex, expandable) => {
        if (expandable)
            await this.props.dispatch(this.props.dataItem.treeOperation(rowIndex, true));

        const key = this.props.dataItem.getRowKeyByIndex(rowIndex);
        const row = this.props.dataItem.getRow(rowIndex);
        console.log(`row: ${JSON.stringify(row)}`);
        //await this.getChapters(key);
    }
    
    
    async getChapters(key) {
        this.setState({defaultKey:key});

/*        await this.props.dispatch(this.props.getList.execute(key));

        if (this.props.getList.rowsCount()>0)
        {
            await this.selectArticle(this.props.getList.getCurrentRowIndex())
        }
        else
            this.resetState();*/
    }

    /*selectArticle = async (i) => {
        const key = this.props.getList.getRowKeyByIndex(i);
        await this.props.dispatch(this.props.describe.execute(key));

        try {
            const val = await this.getBinaryFieldJson(this.props.getList.controllerName, this.props.describe.methodName, 0, "Bin");
            const txtData = val.value;
            this.setState({txtValue: txtData});
        }
        catch (e) {
            this.props.dispatch(ea.errorRaised(e));
        }
    }*/

    renderRow = (rowData) => {

        let {treeData, row, rowIndex, label, isSelected, collapse, expand} = rowData;
        let image = <span/>;
        let ctrl = ()=>{};

        let cursorType = "auto";

        const self = this;

        const expandable = !treeData.IsExpanded && row.IsGroup === 1;
        const collapsable = treeData.IsExpanded && row.IsGroup === 1;
        console.log(`expandable: ${expandable} collapsable: ${collapsable}`);
        if (expandable) {
            ctrl = function (e) {
                e.preventDefault();
                expand(rowIndex);
            };
            image = <i className="zmdi zmdi-chevron-right" onClick={ctrl}/>;
            cursorType = "pointer";
        } else if (collapsable) {
            ctrl = function (e) {
                e.preventDefault();
                collapse(rowIndex);
            };
            image = <i className="zmdi zmdi-chevron-down" onClick={ctrl}/>;
        }
        else{
            if(row.IsGroup === 1){
                image = <i className="zmdi zmdi-folder" />;
            }
            else {
                image = <i className="zmdi zmdi-file" />;
                label = row.DocFormatText ? `${label}.${row.DocFormatText}` : label;
            }
        }

        let backColor = "transparent";

        if (rowIndex === this.props.dataItem.getRowIndex(this.state.defaultKey))
            backColor = "#DDDDDD";

        const docBodyField = this.props.dataItem.getFieldInfo("DocBody");
        return (
        <div style={{
                marginLeft: treeData.Level * 20,
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: backColor
            }} key={row[this.props.keyFieldName]}>
                <label className={"lt-label"} style={{cursor: cursorType, paddingLeft: "5px", paddingRight: "5px"}}>
                    {image}&nbsp;
                    {row.IsGroup === 1 && <span style={{cursor: "pointer"}} onClick={async ()=>await self.selectTreeRow(rowIndex, expandable)}>{label}</span>}
                    {row.IsGroup === 0 && <FileDownloadHandle fieldInfo={docBodyField} rowIndex={rowIndex} dataItem={this.props.dataItem} formattedVal={label} readOnly={true}/>}
                </label>
            </div>
        );
    }
    render() {
        return (
            <>
                <div className="row">
                    <div className="col-md-12" >
                        <BaseMnTree dataItem={this.props.dataItem} dispatch={this.props.dispatch} nodeRender={this.nodeRender} renderRow={this.renderRow}/>
                    </div>
                </div>
            </>
        )
    }
}

Acquaintance_LNA.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object
}

Acquaintance_LNA.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
//        appParams: state.appState.appParams,
        dataItem: state.acquaitanceState.ReceiveSysDoc_TreeDocForPO
    }
}

export default connect(mapStateToProps)(Acquaintance_LNA)